export default __webpack_public_path__ + "static/media/monsterra-world-bg.d9a64d5e.webp";